import { useSelector } from "react-redux";

import classes from './AlertsDetails.module.css'
import AlertsItem from "./AlertsItem";

export default function AlertsDetails() {
    const activeCase = useSelector(state => state.case.activeCase)         
    const searchedAlertsResult = useSelector(state => state.alerts.filterResult)

    return <div className={classes.container}>
        <div className={classes.items_overflow_container}>
            <table className="table-plain table-border-radius-8">
                <thead>
                    <tr>
                        <th>Date added</th>
                        <th>Added by</th>
                        <th>Notes</th>
                        <th>Resolve</th>
                    </tr>
                </thead>
                <tbody>
                    {!searchedAlertsResult && activeCase && activeCase.case_alerts.map(item => (
                        <AlertsItem key={item.id} itemData={item}/>
                    ))}
                    {searchedAlertsResult && searchedAlertsResult.length > 0 && searchedAlertsResult.map(item => (
                        <AlertsItem key={item.id} itemData={item}/>
                    ))}
                    {searchedAlertsResult && searchedAlertsResult.length == 0 && <tr>
                        <td colSpan="8">No results found!</td>
                    </tr>}
                </tbody>
            </table>
        </div>
    </div>

}